import styled, { css } from 'styled-components';
import { mb, mr } from '@upgrade/react-components/Spacing/core';
import * as typographySizes from './typography-sizes';

const headingSizeMap = {
  h1: 'xl',
  h2: 'lg',
  h3: 'md',
  h4: 'sm',
  h5: 'xs',
  h6: 'xxs'
};

const getSizing = ({ viewport, size, heading, as }) => {
  const sizeValue = size || (heading && headingSizeMap[as]);
  if (!sizeValue) return '';
  return typographySizes[heading ? 'headings' : 'text'][viewport][sizeValue];
};

const getWeight = ({ $weight, $bold }) => ($weight === 'bold' || $bold ? '500' : $weight);

const dottedStyles = ({ $dotted, theme }) =>
  $dotted
    ? css`
        padding-bottom: 2px;

        border-bottom: none;
        background-image: linear-gradient(
          to right,
          ${theme.palette.semanticInfoStrong} 40%,
          ${theme.palette.semanticInfoStrong}00 20%
        );
        background-repeat: repeat-x;
        background-position: bottom;
        background-size: 5px 2px;
      `
    : undefined;

export const responsiveFontSize = args => {
  let s;
  let h;
  if (typeof args === 'string') {
    s = args;
  } else if (typeof args === 'object') {
    ({ s, h } = args);
  }

  return ({ $size, $heading, as, theme }) => {
    const size = s || $size;
    const heading = h || $heading;
    // Dont output responsive styles for undefined text sizes
    const outputResponsive = heading || (!heading && size !== undefined);

    return css`
      ${getSizing({ viewport: 'mobile', size, heading, as, theme })};

      ${outputResponsive
        ? css`
            @media (min-width: ${props => props.theme.mediaSm}) {
              ${getSizing({ viewport: 'desktop', size, heading, as, theme })}
            }
          `
        : ''}
    `;
  };
};

export const StyledText = styled.span`
  ${responsiveFontSize()};

  font-weight: ${getWeight};
  font-style: ${({ $italic }) => ($italic ? 'italic' : 'normal')};
  text-align: ${({ $align }) => $align};
  color: ${({ $color, theme }) => theme.palette[$color] || $color};
  text-transform: ${({ $transform }) => $transform};
  letter-spacing: ${({ $letterSpacing }) => $letterSpacing};
  ${({ $marginBottom }) => mb($marginBottom)};
  ${({ $marginRight }) => mr($marginRight)};
  ${dottedStyles};
`;

export const Subtext = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.headings.mobile.xl.fontSize};
  line-height: ${({ theme }) => theme.typography.sizes.headings.mobile.xl.lineHeight};
  font-weight: ${({ $weight }) => $weight};
  color: ${({ $color, theme }) => theme.palette[$color] || $color};
  margin-block-start: 1rem;
  margin-block-end: 1rem;
`;
